import React from "react";
// eslint-disable-next-line import/no-extraneous-dependencies
import { Table } from "reactstrap";
import PropTypes from "prop-types";

import style from "./Grid.module.scss";
import Actions from "./Actions";
import { RecurringCommissionType } from "../types";
import { FormattedDate } from "react-intl";
import { CircularProgress } from "../../..";
import { parseDate } from "../../../../utils";

const Grid = ({ commissions, toggleCommission, handleRefresh, fetchs, Link }) => {
  const renderTable = () => {
    if (!commissions || commissions.length === 0) {
      return <EmptyTable loading={!commissions} />;
    }
    return (
      <React.Fragment>
        {commissions.map((c) => (
          <tr key={c.RecurringCommissionId}>
            <td onClick={() => toggleCommission(c)}>{RecurringCommissionType[c.RecurringCommissionType]}</td>
            <td onClick={() => toggleCommission(c)}>
              <FormattedDate value={parseDate(c.RecurringCommissionFrom)} /> -{" "}
              <FormattedDate value={parseDate(c.RecurringCommissionTo)} />
            </td>
            <td onClick={() => toggleCommission(c)}>
              {c.RecurringCommissionExecutionDate ? (
                <FormattedDate value={parseDate(c.RecurringCommissionExecutionDate)} />
              ) : (
                "-"
              )}
            </td>
            <td onClick={() => toggleCommission(c)}>{c.RecurringCommissionStatus}</td>
            <td>
              <Actions commission={c} handleRefresh={handleRefresh} fetchs={fetchs} Link={Link} />
            </td>
          </tr>
        ))}
      </React.Fragment>
    );
  };

  return (
    <div className={`content ${style.desk}`}>
      <Table className={style.table}>
        <thead>
          <tr>
            <th>Type</th>
            <th>Range</th>
            <th>Execution</th>
            <th>Status</th>
            <th />
          </tr>
        </thead>
        <tbody>{renderTable()}</tbody>
      </Table>
    </div>
  );
};

Grid.propTypes = {
  commissions: PropTypes.array,
  toggleCommission: PropTypes.func.isRequired,
  handleRefresh: PropTypes.func.isRequired,
};

const EmptyTable = ({ loading }) => (
  <tr>
    <td colSpan="8" style={{ textAlign: "center", padding: "40px" }}>
      {loading ? (
        <CircularProgress style={{ marginTop: "10%" }} />
      ) : (
        <h4 style={{ textAlign: "center" }}>No Recurring Commissions</h4>
      )}
    </td>
  </tr>
);

EmptyTable.propTypes = {
  loading: PropTypes.bool.isRequired,
};

export default Grid;
